// Goal Marketplace (leads) aggregated campaign stats — served from the
// Redshift lead_campaign_stats table via GET /api/v4/campaign_stats/leads
export const GET_AGG_MARKETPLACE_STATS_FOR_CAMPAIGNS = "GET_AGG_MARKETPLACE_STATS_FOR_CAMPAIGNS"
export const GET_AGG_MARKETPLACE_STATS_FOR_CAMPAIGNS_SUCCESS = "GET_AGG_MARKETPLACE_STATS_FOR_CAMPAIGNS_SUCCESS"
export const GET_AGG_MARKETPLACE_STATS_FOR_CAMPAIGNS_ERROR = "GET_AGG_MARKETPLACE_STATS_FOR_CAMPAIGNS_ERROR"

// Goal Marketplace (leads) source stats for one campaign — served from the
// Redshift lead_source_stats table via
// GET /api/v4/campaigns/:campaign_id/source_stats/leads
export const GET_MARKETPLACE_SOURCE_STATS = "GET_MARKETPLACE_SOURCE_STATS"
export const GET_MARKETPLACE_SOURCE_STATS_SUCCESS = "GET_MARKETPLACE_SOURCE_STATS_SUCCESS"
export const GET_MARKETPLACE_SOURCE_STATS_ERROR = "GET_MARKETPLACE_SOURCE_STATS_ERROR"

// Goal Marketplace (leads) ad group stats for one campaign — served from the
// Redshift lead_ad_group_stats table via
// GET /api/v4/campaigns/:campaign_id/ad_group_stats/leads
export const GET_MARKETPLACE_AD_GROUP_STATS = "GET_MARKETPLACE_AD_GROUP_STATS"
export const GET_MARKETPLACE_AD_GROUP_STATS_SUCCESS = "GET_MARKETPLACE_AD_GROUP_STATS_SUCCESS"
export const GET_MARKETPLACE_AD_GROUP_STATS_ERROR = "GET_MARKETPLACE_AD_GROUP_STATS_ERROR"

// Goal Marketplace (leads) dashboard payloads — served from the v4 dashboard
// stats actions and collected into the existing dashboard state bucket.
export const GET_MARKETPLACE_DASHBOARD_STATS = "GET_MARKETPLACE_DASHBOARD_STATS"
export const CANCEL_MARKETPLACE_DASHBOARD_STATS = "CANCEL_MARKETPLACE_DASHBOARD_STATS"
export const GET_MARKETPLACE_DASHBOARD_STATS_SUCCESS = "GET_MARKETPLACE_DASHBOARD_STATS_SUCCESS"
export const GET_MARKETPLACE_DASHBOARD_STATS_ERROR = "GET_MARKETPLACE_DASHBOARD_STATS_ERROR"
